export default "__VITE_ASSET__m29LZoQn__"